import type { ReactNode } from "react";
import { TruncatedText } from "@carbon6/c6-frontend-design";
import monoStyles from "@/components/table/dataTableMono.module.css";
import { BranchHashCell } from "@/components/table/branchHash";
import { sessionLearningCore } from "./trainingSessionDetailFormat";

// 세션 상세의 코드 출처 셀. 세 카드(주요 정보·Config·분석)가 Policy·Results 표와 같은
// `BranchHashCell` 로 그린다. 그래서 값 복사와 잘림 툴팁을 공유한다.
// recipe 타입은 포맷 함수에서 가져온다. 그래서 `@/api` 배럴 import 를 늘리지 않는다
// (boundaries ratchet).
export function SessionBranchHash({
  recipe,
}: {
  recipe: Parameters<typeof sessionLearningCore>[0];
}): ReactNode {
  const { branch, shortHash } = sessionLearningCore(recipe);
  if (recipe?.learning_core && recipe.learning_core.kind !== "branch") {
    return <TruncatedText className={monoStyles.mono}>{branch}</TruncatedText>;
  }
  return <BranchHashCell branch={branch} hash={shortHash} fullHash={recipe?.learning_core?.sha} />;
}
